import { createContext } from 'react';
import { wrap } from '@hilma/tools';
export var StationInfoContext = createContext(null);
var StationInfoProvider = function (_a) {
    var station = _a.station, children = _a.children;
    return wrap([StationInfoContext.Provider, { value: station }])(children);
};
export default StationInfoProvider;
//# sourceMappingURL=StationInfoProvider.js.map